import {https, httpsFile} from './http.js';

export function index(page, currentpage,sortby,sortdir, search,status, plant,issuing_plant, tab, created_by,showOpenOnly) {
    return httpsFile().get(`stock-transfer?page=${page}&currentpage=${currentpage}&sortby=${sortby}&sortdir=${sortdir}&search=${search}&status=${status}&plant=${plant}&tab=${tab}&created_by=${created_by}&issuing_plant=${issuing_plant}&showOpenOnly=${showOpenOnly}`);
}

export function showApprovedList(page, currentpage,sortby,sortdir, search,status, plant, issuing_plant) {
    return httpsFile().get(`showApprovedList?page=${page}&currentpage=${currentpage}&sortby=${sortby}&sortdir=${sortdir}&search=${search}&status=${status}&plant=${plant}&issuing_plant=${issuing_plant}`);
}

export function showApprovedByMatList(page, currentpage,sortby,sortdir, search,status, plant, issuing_plant, date_from, date_to) {
    return httpsFile().get(`showApprovedByMatList?page=${page}&currentpage=${currentpage}&sortby=${sortby}
    &sortdir=${sortdir}&search=${search}&status=${status}&plant=${plant}&issuing_plant=${issuing_plant}&date_from=${date_from}&date_to=${date_to}`);
}

export function exportApprovedByMatList(page, currentpage,sortby,sortdir, search,status, plant, issuing_plant, date_from, date_to) {
    return httpsFile().get(`exportApprovedByMatList?page=${page}&currentpage=${currentpage}&sortby=${sortby}
    &sortdir=${sortdir}&search=${search}&status=${status}&plant=${plant}&issuing_plant=${issuing_plant}&date_from=${date_from}&date_to=${date_to}`);
}

export function showUnprocessedRequests(page, currentpage,sortby,sortdir, search,isForApproval = false,receiving_store_loc = 'all') {
    return httpsFile().get(`showUnprocessedRequests?page=${page}&currentpage=${currentpage}&sortby=${sortby}&sortdir=${sortdir}&search=${search}&isForApproval=${isForApproval}&receivingStoreLoc=${receiving_store_loc}`);
}
export function showUnprocessedTransferOutRequests(page, currentpage,sortby,sortdir, search,status, plant, tab, created_by,receiving_store_loc ='all') {
    return httpsFile().get(`showUnprocessedTransferOutRequests?page=${page}&currentpage=${currentpage}&sortby=${sortby}&sortdir=${sortdir}&search=${search}&status=${status}&plant=${plant}&tab=${tab}&created_by=${created_by}&receivingStoreLoc=${receiving_store_loc}`);
}

export function showTransactionHistory(page, currentpage,sortby,sortdir, search) {
    return httpsFile().get(`showTransactionHistory?page=${page}&currentpage=${currentpage}&sortby=${sortby}&sortdir=${sortdir}&search=${search}`);
}
export function showRequestHistory(page, currentpage,sortby,sortdir, search,subject) {
    return httpsFile().get(`showRequestHistory?page=${page}&currentpage=${currentpage}&sortby=${sortby}&sortdir=${sortdir}&search=${search}&subject=${subject}`);
}

export function showForReceiving(page, currentpage,sortby,sortdir, search, plant = null, issuing_plant = null) {
    return httpsFile().get(`showForReceiving?page=${page}&currentpage=${currentpage}&sortby=${sortby}&sortdir=${sortdir}&search=${search}&plant=${plant}&issuing_plant=${issuing_plant}`);
}

export function showForConfirmation(page, currentpage,sortby,sortdir, search) {
    return httpsFile().get(`showForConfirmation?page=${page}&currentpage=${currentpage}&sortby=${sortby}&sortdir=${sortdir}&search=${search}`);
}

export function show(id,page,currentpage,showzero){
    return https().get(`stock-transfer/${id}?page=${page}&currentpage=${currentpage}&showzero=${showzero}`);
}

export function showUnprocessedStorLocTrans(id,page,currentpage){
    return https().get(`showUnprocessedStorLocTrans/${id}?page=${page}&currentpage=${currentpage}`);
}
export function showUnprocessedTransferOut(id,page,currentpage){
    return https().get(`showUnprocessedTransferOut/${id}?page=${page}&currentpage=${currentpage}`);
}

export function processtorLocTrans(form_data){
    return https().post(`processStorLocTrans`,form_data);
}
export function processTransferOut(form_data){
    return https().post(`processTransferOut`,form_data);
}

export function showForReceivingDetails(id,page,currentpage){
    return https().get(`showForReceivingDetails/${id}?page=${page}&currentpage=${currentpage}`);
}

export function store(data){
    return https().post(`stock-transfer`,data);
}
export function submitEmail(data){
    return https().post(`submitEmail`,data);
}
// export function updateStatus(id,status,items,hdr_remarks,header){
//     return https().get(`updateStatus?id=${id}&status_id=${status}&items=${items}&hdr_remarks=${hdr_remarks}&header=${header}`);
// }
export function updateStatus(data){
    return https().post(`updateStatus`, data);
}
export function updateApprovedItem(data){
    return https().post(`updateApprovedItem`, data);
}
// export function approveRequest(id,nextApprover,details){
//     return https().get(`approveRequest?id=${id}&nextApprover=${nextApprover}&details=${details}`);
// }

export function approveRequest(data){
    return https().post(`approveRequest`,data);
}

export function receiveRequest(data){
    return https().post(`receiveRequest`,data);
}

export function saveReceiveRequest(data){
    return https().post(`saveReceiveRequest`,data);
}

export function confirmRequest(data){
    return https().post(`confirmRequest`,data);
}
export function showReadyForTransfer(page,currentpage,plant,search, draft_id = null){
    return https().get(`showReadyForTransfer?plant=${plant}&page=${page}&currentpage=${currentpage}&search=${search}&draft_id=${draft_id}`);
}
export function showReservedMaterials(page,currentpage,plant,search){
    return https().get(`showReservedMaterials?plant=${plant}&page=${page}&currentpage=${currentpage}&search=${search}`);
}
export function showEmailNotification(page, currentpage,sortby,sortdir, search){
    return httpsFile().get(`showEmailNotification?page=${page}&currentpage=${currentpage}&sortby=${sortby}&sortdir=${sortdir}&search=${search}`);
}

export function createDamageReport(data){
    return https().post(`createDamageReport`,data);
}
export function saveDamageReport(data){
    return https().post(`saveDamageReport`,data);
}
export function saveTransferOut(data){
    return https().post(`saveTransferOut`,data);
}
export function createTransferOut(data){
    return https().post(`createTransferOut`,data);
}

export function manualExportDamage(id,movement_type){
    return https().get(`manualExportDamage?id=${id}&movement_type=${movement_type}`);
}
export function updateStockTranferIssuingStoreloc(new_val,st_id,change_for,matnr = null,storloc_for = null,new_receiving_store_loc = null){
    return https().get(`updateStockTranferIssuingStoreloc?st_id=${st_id}&new_val=${new_val}&change_for=${change_for}&matnr=${matnr}&storloc_for=${storloc_for}&new_receiving_store_loc=${new_receiving_store_loc}`);
}
export function getComponents(matnr,plant,issuing_plant){
    return https().get(`getComponents?matnr=${matnr}&plant=${plant}&issuing_plant=${issuing_plant}`);
}
export function getInventories(matnr){
    return https().get(`getInventories?matnr=${matnr}`);
}
export function getApprovedQty(matnr,issuing_plant){
    return https().get(`getApprovedQty?matnr=${matnr}&issuing_plant=${issuing_plant}`);
}
export function getSupplierPRST(){
    return https().get(`getSupplierPRST`);
}
